import React, { ReactElement, useEffect, useState } from 'react';
import useStyles from './styles';
interface componentProps {
    titles: Array<string | ReactElement>
    values: Array<any>,
    onSelected: (selectedControl: any) => void,
    model: any
}
const JetSegmentedControl = (props: componentProps) => {
    const classes = useStyles();
    const { titles, values, model } = props
    const [selectedControl, setSelectedControl] = useState(model)
    useEffect(() => {
        if (selectedControl !== model) {
            props.onSelected(selectedControl)
        }
    }, [selectedControl]);
    useEffect(() => { setSelectedControl(model) }, [model])
    return <div className={classes.jetSegmentedControllerContainer}>
        {titles.map((title, index) => (<div
            key={index}
            className={`control ${props.model === values[index] ? 'active' : ''} ${values[index] === null ? 'disabled' : ''}`}
            onClick={() => { setSelectedControl(values[index]); }}
            tabIndex={index}>
            <div className='innerWrapper'>
                {title}
            </div>
        </div>))}
    </div>
}

export default JetSegmentedControl